export const SAMPLE_ACTION = 'Sample action';
export const SAMPLE_ACTION_2 = 'Sample action 2';
